import { generatePath, useRouteMatch } from 'react-router-dom';
import classNames from 'classnames';
import { t } from 'ttag';

import { productReviews } from '@urls';
import { productDetails } from '@legacyUrls';
import { Title } from '@ui/Title';
import { Button } from '@ui/Button';
import { ProductReview, Review } from '@components/ProductReview';

import s from './ProductDetailsReviews.sss';

interface MatchParams {
  namespace: string,
  category: string,
  slug: string,
  productId: string,
}

interface Props {
  className?: string,
  reviews: Review[],
  isHasMore: boolean,
}

export const ProductDetailsReviews: React.FC<Props> = ({
  className,
  reviews,
  isHasMore,
}) => {
  const match = useRouteMatch<MatchParams>(productDetails);

  const allReviewsPath = match ? generatePath(productReviews, {
    namespace: match.params.namespace,
    category: match.params.category,
    slug: match.params.slug,
    productId: match.params.productId,
  }) : null;

  return (
    <div className={classNames(s.root, className)}>
      <Title
        className={s.title}
        type='h3'
        bold={false}
      >
        {t`Відгуки про товар`}
      </Title>

      <ul className={s.list}>
        {reviews.map((review) => (
          <li
            key={review.id}
            className={s.item}
          >
            <ProductReview review={review} />
          </li>
        ))}
      </ul>

      {isHasMore && allReviewsPath && (
        <Button
          className={s.button}
          theme="secondary"
          to={decodeURIComponent(allReviewsPath)}
        >
          {t`Дивитись всі відгуки`}
        </Button>
      )}
    </div>
  );
};
